<template>
  <vx-card title="Customer Invoice Exchange">
    <div class="flex flex-col gap-3">
      <operating-unit-filter @onShow="onShow" :multipleTerritory="true" />
      <vs-tabs>
        <vs-tab label="Waiting Approval">
          <div class="con-tab-ejemplo">
            <waiting :isReload="isReload" />
          </div>
        </vs-tab>
        <vs-tab label="Approved">
          <div class="con-tab-ejemplo">
            <approve :isReload="isReload" />
          </div>
        </vs-tab>
        <vs-tab label="Rejected">
          <div class="con-tab-ejemplo"><reject :isReload="isReload" /></div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>

<script>
import approve from "./approved/index.vue";
import reject from "./rejected/index.vue";
import waiting from "./waiting/index.vue";
import operatingUnitFilter from "@/components/operatingUnitFilter/operatingUnitFilter.vue";
export default {
  components: {
    approve,
    reject,
    waiting,
    "operating-unit-filter": operatingUnitFilter,
  },
  data() {
    return {
      isReload: false,
    };
  },
  methods: {
    onShow() {
      this.isReload = true;
      this.$nextTick(() => {
        this.isReload = false;
      });
    },
  },
};
</script>
